import React from 'react';
import '../App.css';
import logo from "../foreverautumnlogo.png"

class Home extends React.Component {
  render(){
    return (
      <div className="Home">
        <h1 className="headers">Forever Autumn Records</h1>
        <h3>Welcome to Forever Autumn Records</h3>
        <img className="logo" src={logo} />
        <p>Copyright © {new Date().getFullYear()} Forever Autumn Records - All Rights Reserved.</p>
      </div>
    );
  }
}

export default Home;
